module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Transportation Reports ")])], 1), _vm._v(" "), _c('div', [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "pills": "",
      "card": "",
      "vertical": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "TPT Dashboard",
      "active": ""
    }
  }, [_c('b-card-text', [_vm._v("TPT Dashboard Content will come here")])], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Reports"
    }
  }, [_c('b-card-text', {
    staticClass: "mt-3"
  }, [_c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "8",
      "offset-md": "2"
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inline-form-custom-select-pref"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "8",
      "offset-md": "2"
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inline-form-custom-select-pref"
    }
  }, [_vm._v("Date Range")]), _c('date-range-picker', {
    ref: "picker",
    attrs: {
      "always-show-calendars": _vm.showCal,
      "opens": "right",
      "locale-data": _vm.locale
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function(picker) {
        return _c('div', {}, [_vm._v("\n                        " + _vm._s(_vm._f("moment")(_vm.dateRange.startDate)) + " -\n                        " + _vm._s(_vm._f("moment")(_vm.dateRange.endDate)) + "\n                      ")])
      }
    }]),
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'GR Tracking Report' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('GR_TRACKING_REPORT', 'GR Tracking Report')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.ExcelBtnName) + "\n                      "), (_vm.ExcelBtnName != 'GR Tracking Report') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "disabled": _vm.ExcelBtnTPTName != 'TPT Trucking Analysis Report' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('TRUCKING_ANALYSIS_REPORT', 'TPT Trucking Analysis Report')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.ExcelBtnTPTName) + "\n                      "), (_vm.ExcelBtnTPTName != 'TPT Trucking Analysis Report') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "PopDoc",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-704291dd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/reports/newTransportationReports.vue
// module id = 2740
// module chunks = 0